export default "__VITE_ASSET___G9d214y__"